import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './Countdown';
import { PricingSelector } from './PricingSelector';
export function FinalCTASection() {
  return <section className="py-10 sm:py-16 lg:py-24 bg-navy-900 relative overflow-hidden" data-id="element-101">
      <div className="absolute inset-0 bg-radial-glow opacity-60 pointer-events-none" data-id="element-102" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-104">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-display text-offwhite uppercase mb-4 sm:mb-6" data-id="element-105">
            No dejes pasar esta{' '}
            <span className="text-gold-500" data-id="element-106">oportunidad</span>
          </h2>

          <div className="flex flex-col items-center justify-center gap-2 sm:gap-4 mb-6 sm:mb-10" data-id="element-107">
            <span className="text-xs sm:text-sm md:text-base text-text-secondary font-medium" data-id="element-108">
              Termina en:
            </span>
            <Countdown className="scale-100 sm:scale-110 md:scale-125" data-id="element-109" />
          </div>

          <div className="bg-navy-800 border-2 border-gold-500/40 rounded-3xl p-5 sm:p-8 md:p-10 shadow-2xl" data-id="element-110">
            <PricingSelector data-id="element-111" />
          </div>
        </motion.div>
      </div>
    </section>;
}